import { FormControl, InputLabel, Select } from '@material-ui/core';
import React, { FC } from 'react';
import { createUseStyles } from 'src/theming';

const useStyles = createUseStyles({
  root: {
    minWidth: '120px !important',
    maxWidth: 300,
  },
});

const status = {
  draft: 'Brouillon',
  sended: 'Envoyé',
};

interface Props {
  onChange: (value: string) => void;
  value: string;
}

const StatusSelect: FC<Props> = ({ onChange, value }) => {
  const classes = useStyles();

  const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    onChange(event.target.value as string);
  };

  return (
    <FormControl className={classes.root}>
      <InputLabel>Statut</InputLabel>
      <Select native value={value} onChange={handleChange}>
        <option value='' />
        {Object.keys(status).map((statusKey) => (
          <option key={statusKey} value={statusKey}>
            {status[statusKey]}
          </option>
        ))}
      </Select>
    </FormControl>
  );
};

export default StatusSelect;
